/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NonceChallengeOptions } from './NonceChallengeOptions';
import {
    NonceChallengeOptionsFromJSON,
    NonceChallengeOptionsFromJSONTyped,
    NonceChallengeOptionsToJSON,
} from './NonceChallengeOptions';

/**
 * 
 * @export
 * @interface NonceChallengeAllOf
 */
export interface NonceChallengeAllOf {
    /**
     * 
     * @type {NonceChallengeOptions}
     * @memberof NonceChallengeAllOf
     */
    options?: NonceChallengeOptions;
}

/**
 * Check if a given object implements the NonceChallengeAllOf interface.
 */
export function instanceOfNonceChallengeAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonceChallengeAllOfFromJSON(json: any): NonceChallengeAllOf {
    return NonceChallengeAllOfFromJSONTyped(json, false);
}

export function NonceChallengeAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceChallengeAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'options': !exists(json, 'options') ? undefined : NonceChallengeOptionsFromJSON(json['options']),
    };
}

export function NonceChallengeAllOfToJSON(value?: NonceChallengeAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'options': NonceChallengeOptionsToJSON(value.options),
    };
}

